<template>
  <div>
    <div class="p-16">
      <div class="max-w-5xl mx-auto">
        <div class="space-y-16">
          <div class="flex items-center justify-between">
            <h4 class="text-indigo-500 capitalize">Προϊόντα</h4>
          </div>
          <div class="flex -mx-4">
            <div class="w-64 px-4">
              <SidebarFilters :disabled="fetching" />
            </div>
            <div class="flex-1 px-4">
              <BaseAdvancedList
                searchable
                :loading="fetching"
                :with-list-header="listHeader"
                :with-list-item="listItem"
                :entities="products"
                :meta="meta"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';
import ListHeader from '@/components/Products/ListHeader.vue';
import ListItem from '@/components/Products/AdminListItem.vue';
import SidebarFilters from '@/components/Products/SidebarFilters.vue';

export default {
  name: 'AccountProductsView',
  components: {
    SidebarFilters,
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...mapGetters('admin/products', ['products']),
    ...mapState('admin/products', ['meta', 'links']),
    listHeader() {
      return ListHeader;
    },
    listItem() {
      return ListItem;
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('admin/products', ['fetchProductList']),
    ...mapMutations('admin/products', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { query: params } = this.$route;
      const include = 'media,categories';
      this.fetching = true;
      try {
        await this.fetchProductList({ params: { ...params, include } });
      } catch (error) {
        //
      }
      this.fetching = false;
    },
  },
};
</script>
